/* QUIETUDE theme — carousel, FAQ, reviews strip, product page */
(function () {
  var track = document.getElementById('car-track');
  if (track) {
    var btns = [].slice.call(document.querySelectorAll('.car-btn'));
    var step = function () {
      var c = track.querySelector('.acc-card');
      return c ? c.getBoundingClientRect().width + 14 : 280;
    };
    var sync = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (btns[0]) btns[0].disabled = track.scrollLeft <= 2;
      if (btns[1]) btns[1].disabled = track.scrollLeft >= max;
    };
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: step() * parseInt(b.getAttribute('data-dir'), 10), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  var faq = document.getElementById('faq-list');
  if (faq) {
    faq.addEventListener('click', function (e) {
      var q = e.target.closest('.faq-q');
      if (!q) return;
      var item = q.parentElement, body = item.querySelector('.faq-a');
      var open = item.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
    });
  }

  var dots = document.getElementById('rv-dots');
  if (dots) {
    var texts = [].slice.call(document.querySelectorAll('[data-rv-text]'));
    dots.addEventListener('click', function (e) {
      var d = e.target.closest('.rv-dot');
      if (!d) return;
      var i = parseInt(d.getAttribute('data-rv'), 10);
      texts.forEach(function (t, j) { t.hidden = j !== i; });
      [].slice.call(dots.children).forEach(function (b, j) { b.classList.toggle('on', j === i); });
    });
  }

  var burger = document.querySelector('.burger');
  var nav = document.getElementById('nav-drawer');
  var scrim = document.getElementById('scrim');
  if (burger && nav) {
    var openNav = function (o) {
      nav.classList.toggle('on', o);
      if (scrim) scrim.classList.toggle('on', o);
      nav.setAttribute('aria-hidden', String(!o));
    };
    burger.addEventListener('click', function () { openNav(true); });
    var close = document.getElementById('nav-close');
    if (close) close.addEventListener('click', function () { openNav(false); });
    if (scrim) scrim.addEventListener('click', function () { openNav(false); });
  }
})();

/* ── product page: gallery, variants, tabs ── */
(function () {
  var thumbs = document.getElementById('pdp-thumbs');
  var main = document.getElementById('pdp-img');
  if (thumbs && main) {
    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.pdp-thumb');
      if (!t) return;
      [].slice.call(thumbs.children).forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      main.src = t.getAttribute('data-src');
    });
  }

  var row = document.getElementById('opt-row');
  if (row) {
    row.addEventListener('click', function (e) {
      var b = e.target.closest('.variant-pill');
      if (!b || b.disabled) return;
      [].slice.call(row.children).forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      document.getElementById('variant-id').value = b.getAttribute('data-variant');
      var label = document.getElementById('opt-value');
      if (label) label.textContent = b.getAttribute('data-title');
      var price = document.querySelector('.price-now');
      if (price) price.textContent = b.getAttribute('data-price');
    });
  }

  var heads = document.querySelector('.tab-heads');
  if (heads) {
    heads.addEventListener('click', function (e) {
      var h = e.target.closest('.tab-h');
      if (!h) return;
      var i = h.getAttribute('data-tab');
      [].slice.call(heads.children).forEach(function (x) { x.classList.remove('on'); });
      h.classList.add('on');
      document.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-tab-panel') !== i;
      });
    });
  }
})();

/* ── cart drawer, backed by Shopify's AJAX Cart API ── */
(function () {
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var body = document.getElementById('drawer-body');
  var totalEl = document.getElementById('cart-total');
  if (!drawer || !body) return;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function open(o) {
    drawer.classList.toggle('on', o);
    if (scrim) scrim.classList.toggle('on', o);
    drawer.setAttribute('aria-hidden', String(!o));
  }

  function render(cart) {
    document.querySelectorAll('.cart-count').forEach(function (c) {
      c.textContent = cart.item_count;
    });
    if (totalEl) totalEl.textContent = money(cart.total_price);
    var checkout = document.getElementById('cart-checkout');
    if (checkout) checkout.disabled = cart.item_count === 0;

    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer-empty">Your cart is empty.</p>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">'
        : '<span class="line-media-empty"></span>';
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<p class="line-variant">' + it.variant_title + '</p>' : '';
      return '<div class="line">' +
        '<div class="line-media">' + img + '</div>' +
        '<div class="line-text">' +
          '<p class="line-name">' + it.product_title + '</p>' + variant +
          '<div class="qty">' +
            '<button class="qty-btn" data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<span class="qty-n">' + it.quantity + '</span>' +
            '<button class="qty-btn" data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="line-right">' +
          '<p class="line-price">' + money(it.final_line_price) + '</p>' +
          '<button class="line-remove" data-key="' + it.key + '" data-qty="0">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function refresh(openAfter) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (openAfter) open(true); })
      .catch(function () { /* keep the server-rendered state */ });
  }

  /* add to cart without leaving the page */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function () { return refresh(true); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* quantity and removal */
  body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-key]');
    if (!b) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: parseInt(b.getAttribute('data-qty'), 10) })
    }).then(function (r) { return r.json(); }).then(render);
  });

  document.querySelectorAll('.cart-btn').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
  });
  var close = document.getElementById('cart-close');
  if (close) close.addEventListener('click', function () { open(false); });
  if (scrim) scrim.addEventListener('click', function () { open(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });

  refresh(false);
})();
